import { galactica, galacticaCassiopeia } from './chains';

// Cassiopeia testnet chain ID: 843843
// Mainnet chain ID: 613419

export const contracts = {
  votingEscrow: {
    [galactica.id]: '0xdFbE5AC59027C6f38ac3E2eDF6292672A8eCffe4' as const,
    [galacticaCassiopeia.id]: '0xeF6C9f6DB8d5b93d0248f2d8297D2a3913024A26' as const,
  },
  indexPool: {
    [galactica.id]: '0x50AF2AAb1455C1C06B3b8e623549dDE437F54EeF' as const,
    [galacticaCassiopeia.id]: '0x03AfdAE87e9E02D65ffe61BD87CF5981132a453b' as const,
  },
  gubi: {
    [galactica.id]: undefined as unknown as `0x${string}`, // TODO: Add mainnet address
    [galacticaCassiopeia.id]: '0x5b9A231e9bBC26C81f80790fA307Ce5595635eDF' as const,
  },
  multicall: {
    [galactica.id]: '0xcA11bde05977b3631167028862bE2a173976CA11' as const,
    [galacticaCassiopeia.id]: '0xcA11bde05977b3631167028862bE2a173976CA11' as const,
  },
  wrappedGnet: {
    [galactica.id]: '0x690f1eef8acead09ac695d9111af081045c6d5b7' as const,
    [galacticaCassiopeia.id]: '0x3CC60CeD9c4896B284EF6f95D14137945aA319fb' as const,
  },
} as const;

export type ContractName = keyof typeof contracts;
